<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.scope_type') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="scopeTypeFilter"
          :options="localScopeTypeOptions"
          class="w-100"
          :label="catalogLabelKey"
          :reduce="catalogReduceFn"
          @input="(val) => $emit('update:scopeTypeFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          clearable
        />
      </b-col>
      <b-col v-if="showUnitFilter" cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.inmuebles') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="unitFilter"
          :options="localUnitOptions"
          class="w-100"
          :label="unitLabelKey"
          :reduce="unitReduceFn"
          @input="(val) => $emit('update:unitFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          clearable
        />
      </b-col>
      <b-col v-else-if="showSectorFilter" cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.regions') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="sectorIdsFilter"
          :options="localSectorOptions"
          class="w-100"
          :label="catalogLabelKey"
          :reduce="catalogReduceFn"
          multiple
          @input="(val) => $emit('update:sectorIdsFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          clearable
        />
      </b-col>
    </b-row>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.request_type') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="requestTypeFilter"
          :options="localRequestTypeOptions"
          class="w-100"
          :label="catalogLabelKey"
          :reduce="catalogReduceFn"
          @input="(val) => $emit('update:requestTypeFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          clearable
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.status') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="statusFilter"
          :options="localStatusOptions"
          class="w-100"
          :label="statusLabelKey"
          :reduce="statusReduceFn"
          @input="(val) => $emit('update:statusFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          clearable
        />
      </b-col>
    </b-row>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.exception_type') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="exceptionTypeFilter"
          :options="localExceptionTypeOptions"
          class="w-100"
          :label="catalogLabelKey"
          :reduce="catalogReduceFn"
          @input="(val) => $emit('update:exceptionTypeFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          clearable
        />
      </b-col>
      <b-col v-if="showStandardsFilter" cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.standards') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="standardIdsFilter"
          :options="standardOptions"
          class="w-100"
          :label="standardLabelKey"
          :reduce="standardReduceFn"
          multiple
          @input="(val) => $emit('update:standardIdsFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          clearable
        />
      </b-col>
    </b-row>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="12" md="4" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.assigned_to') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="assignedToFilter"
          :options="localUserOptions"
          class="w-100"
          :label="userLabelKey"
          :reduce="userReduceFn"
          @input="(val) => $emit('update:assignedToFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          clearable
        />
      </b-col>
      <b-col cols="12" md="4" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.in_review') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="reviewedByFilter"
          :options="localUserOptions"
          class="w-100"
          :label="userLabelKey"
          :reduce="userReduceFn"
          @input="(val) => $emit('update:reviewedByFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          clearable
        />
      </b-col>
      <b-col cols="12" md="4" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.approved_canceled') }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="approvedByFilter"
          :options="localUserOptions"
          class="w-100"
          :label="userLabelKey"
          :reduce="userReduceFn"
          @input="(val) => $emit('update:approvedByFilter', val)"
          append-to-body
          :calculate-position="withPopper"
          clearable
        />
      </b-col>
    </b-row>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.created_from') }}</label>
        <flat-pickr
          class="form-control"
          :config="datePickerConfig"
          :value="createdFromFilter"
          @on-change="(selectedDates, val) => $emit('update:createdFromFilter', normalizeDateToYmd(selectedDates, val))"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.created_to') }}</label>
        <flat-pickr
          :key="'created-to-' + (createdFromFilter || '')"
          class="form-control"
          :config="createdToPickerConfig"
          :value="createdToFilter"
          @on-change="(selectedDates, val) => $emit('update:createdToFilter', normalizeDateToYmd(selectedDates, val))"
        />
      </b-col>
    </b-row>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.validity_from') }}</label>
        <flat-pickr
          class="form-control"
          :config="datePickerConfig"
          :value="validityFromFilter"
          @on-change="(selectedDates, val) => $emit('update:validityFromFilter', normalizeDateToYmd(selectedDates, val))"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $t('policy_exception.validity_to') }}</label>
        <flat-pickr
          :key="'validity-to-' + (validityFromFilter || '')"
          class="form-control"
          :config="validityToPickerConfig"
          :value="validityToFilter"
          @on-change="(selectedDates, val) => $emit('update:validityToFilter', normalizeDateToYmd(selectedDates, val))"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import popperHelper from '@/libs/popper-helper'

const DEFAULT_STATUS_VALUES = [
  'scheduled',
  'in_progress',
  'in_review',
  'rejected',
  'approved',
  'canceled',
  'reassigned',
]

const SCOPE_TYPE_UNIT = 1
const SCOPE_TYPE_REGION = 2

const datePickerConfig = { dateFormat: 'Y-m-d', allowInput: false }

function formatOptionLabel(name) {
  return String(name || '').replace(/_/g, ' ')
}

function normalizeDateToYmd(selectedDates, val) {
  if (Array.isArray(selectedDates) && selectedDates.length > 0) {
    const d = selectedDates[0]
    if (d instanceof Date) {
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    }
  }
  if (val instanceof Date) {
    const y = val.getFullYear()
    const m = String(val.getMonth() + 1).padStart(2, '0')
    const day = String(val.getDate()).padStart(2, '0')
    return `${y}-${m}-${day}`
  }
  if (typeof val === 'string' && val.length >= 10) {
    return val.slice(0, 10)
  }
  return val == null ? null : String(val)
}

function isExceptionTypePolitica(exceptionTypeId, options) {
  if (exceptionTypeId == null || exceptionTypeId === '') return false
  const option = (options || []).find(
    (opt) => opt.id === exceptionTypeId || opt.id === Number(exceptionTypeId) || String(opt.name || '').toLowerCase() === String(exceptionTypeId).toLowerCase()
  )
  if (!option) return false
  const name = String(option.name || '').toLowerCase().replace(/[-\s]+/g, '_')
  return name === 'excepcion_politica' || name.includes('politica')
}

function formatUnitOptionLabel(description, sirh, rems) {
  const desc = description != null && description !== '' ? String(description) : ''
  const sirhDisplay = sirh != null && sirh !== '' ? String(sirh) : '-'
  const remsDisplay = rems != null && rems !== '' ? String(rems) : '-'
  const suffix = `SIRH: ${sirhDisplay} | REMS: ${remsDisplay}`
  return desc ? `${desc} | ${suffix}` : suffix
}

export default {
  name: 'FiltersPolicyException',
  components: {
    BRow,
    BCol,
    vSelect,
    flatPickr,
  },
  props: {
    statusFilter: { type: [String, Number, null], default: null },
    scopeTypeFilter: { type: [String, Number, null], default: null },
    requestTypeFilter: { type: [String, Number, null], default: null },
    exceptionTypeFilter: { type: [String, Number, null], default: null },
    unitFilter: { type: [String, Number, null], default: null },
    sectorIdsFilter: { type: Array, default: () => [] },
    standardIdsFilter: { type: Array, default: () => [] },
    assignedToFilter: { type: [String, Number, null], default: null },
    reviewedByFilter: { type: [String, Number, null], default: null },
    approvedByFilter: { type: [String, Number, null], default: null },
    createdFromFilter: { type: [String, null], default: null },
    createdToFilter: { type: [String, null], default: null },
    validityFromFilter: { type: [String, null], default: null },
    validityToFilter: { type: [String, null], default: null },
    statusOptions: { type: Array, default: () => [] },
    scopeTypeOptions: { type: Array, default: () => [] },
    requestTypeOptions: { type: Array, default: () => [] },
    exceptionTypeOptions: { type: Array, default: () => [] },
    unitOptions: { type: Array, default: () => [] },
    sectorOptions: { type: Array, default: () => [] },
    standardOptions: { type: Array, default: () => [] },
    userOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      datePickerConfig,
      formatOptionLabel,
      normalizeDateToYmd,
    }
  },
  computed: {
    withPopper() {
      return popperHelper.withPopper
    },
    showUnitFilter() {
      const v = this.scopeTypeFilter
      return v === SCOPE_TYPE_UNIT || v === '1'
    },
    showSectorFilter() {
      const v = this.scopeTypeFilter
      return v === SCOPE_TYPE_REGION || v === '2'
    },
    showStandardsFilter() {
      return isExceptionTypePolitica(this.exceptionTypeFilter, this.exceptionTypeOptions)
    },
    localStatusOptions() {
      const raw = this.statusOptions.length ? this.statusOptions : DEFAULT_STATUS_VALUES.map((value) => ({ id: value, name: value }))
      return raw.map((opt) => {
        const rawValue = typeof opt === 'string'
          ? opt
          : (opt.name ?? opt.value ?? (opt.id != null ? String(opt.id) : ''))
        const slug = String(rawValue || '').toLowerCase().replace(/[-\s]+/g, '_')
        const i18nKey = slug ? `policy_exception.status_${slug}` : ''
        const translated = i18nKey && this.$t(i18nKey) !== i18nKey ? this.$t(i18nKey) : slug
        const label = translated || (typeof opt === 'object' && opt ? (opt.label ?? opt.name ?? opt.value) : rawValue)
        const id = typeof opt === 'object' && opt && opt.id != null ? opt.id : (slug || rawValue)
        const value = id
        return { ...(typeof opt === 'object' && opt ? opt : {}), label, id, value }
      })
    },
    localScopeTypeOptions() {
      return this.scopeTypeOptions || []
    },
    localUnitOptions() {
      const options = this.unitOptions || []
      return options
        .filter((item) => item != null)
        .map((item) => {
          const id = item.value != null ? item.value : item.id
          const description = item.label ?? item.description ?? item.name ?? ''
          const name = formatUnitOptionLabel(description, item.sirh, item.rems)
          return { id, name, value: id }
        })
    },
    localSectorOptions() {
      const options = this.sectorOptions || []
      return options
        .filter((item) => item != null)
        .map((item) => {
          const id = item.value != null ? item.value : item.id
          const name = item.label ?? item.name ?? String(id)
          return { id, name, value: id }
        })
    },
    localRequestTypeOptions() {
      return this.requestTypeOptions || []
    },
    localExceptionTypeOptions() {
      const options = this.exceptionTypeOptions || []
      return options.map((opt) => ({ ...opt, name: formatOptionLabel(opt.name) }))
    },
    localUserOptions() {
      const options = this.userOptions || []
      return options.map((item) => {
        if (item != null && (item.value != null || item.id != null)) {
          const id = item.value != null ? item.value : item.id
          const name = item.label != null ? item.label : (item.name != null ? item.name : String(id))
          return { id, name, value: id }
        }
        return item
      })
    },
    createdToPickerConfig() {
      const base = { dateFormat: 'Y-m-d', allowInput: false }
      if (!this.createdFromFilter) return base
      const fromStr = String(this.createdFromFilter).slice(0, 10)
      if (/^\d{4}-\d{2}-\d{2}$/.test(fromStr)) {
        base.minDate = new Date(fromStr + 'T00:00:00')
      }
      return base
    },
    validityToPickerConfig() {
      const base = { dateFormat: 'Y-m-d', allowInput: false }
      if (!this.validityFromFilter) return base
      const fromStr = String(this.validityFromFilter).slice(0, 10)
      if (/^\d{4}-\d{2}-\d{2}$/.test(fromStr)) {
        base.minDate = new Date(fromStr + 'T00:00:00')
      }
      return base
    },
    statusLabelKey() {
      return 'label'
    },
    statusReduceFn() {
      return (item) => item.id ?? item.value
    },
    catalogLabelKey() {
      return 'name'
    },
    catalogReduceFn() {
      return (item) => (item != null && (item.id != null || item.id === 0)) ? item.id : (item && item.value != null ? item.value : item)
    },
    unitLabelKey() {
      return 'name'
    },
    unitReduceFn() {
      return (item) => (item != null && (item.id != null || item.id === 0)) ? item.id : (item && item.value != null ? item.value : item)
    },
    standardLabelKey() {
      return 'name'
    },
    standardReduceFn() {
      return (item) => (item && (item.id != null || item.id === 0)) ? item.id : item
    },
    userLabelKey() {
      return 'name'
    },
    userReduceFn() {
      return (item) => (item != null && (item.id != null || item.id === 0)) ? item.id : (item && item.value != null ? item.value : item)
    },
  },
}
</script>
